import React, { useState } from "react";
import Header from "./Header";

const Calculater1 = () => {
  const [Height, setHeight] = useState("");
  const [Weight, setWeight] = useState("");
  const [bmi, setBmi] = useState("");
  const [massage, setMessage] = useState("");

  let calcBmi = (event) => {
    //prevent submitting to the server
    event.preventDefault()
 
    if (Weight === 0 || Height === 0) {
      alert('Please enter a valid weight and height')
    } else {
      let bmi = Weight / ((Height * Height)/10000)
      setBmi(bmi.toFixed(1))
 
      // Logic for message
 
      if (bmi < 18.5) {
        setMessage('You are underweight')
      } else if (bmi >= 18.5 && bmi < 24.9) {
        setMessage('You are a healthy weight')
      } else {
        setMessage('You are overweight')
      }
    }
  }
  let reload=()=>{
    window.location.reload()
  }
 
  return (<>
    <Header/>
    <div className="body1" style={{backgroundSize:"cover"}}>
 <br/>
      <div className="box">
      <h3>BMI calculator</h3>
        <br />
         Weight<input
          type="number"
          placeholder="Weight in kilograms"
          className="box__inputs"
          value={Weight}
          onChange={(e)=>setWeight(e.target.value)}
        />
        <br />
        Height <input
          type="number"
          placeholder="Height in centimeters"
          className="box__inputs"
          value={Height}
          onChange={(e)=>setHeight(e.target.value)}
        />
        <br />
        <button className="box__btn" onClick={calcBmi}>Converter</button><br/>
        <button className="box__btn" onClick={reload}>Reload</button>
        <br />
        <input type="text" value={bmi} placeholder="Your BMI" className="box__inputs" />
        <br />
        <div className="bmi__range">
          <h3>{massage}</h3>
        </div>
        <br />
        <br/>
        <p className="card-footer">Created by Samridhi Sachdeva.</p>
      </div>
      
    </div>
   
    </>
  );
};

export default Calculater1;
